import { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { buildListParams } from '../../dataHandlers/queryParams';

const useMeterFilters = ({ defaultQuery = {}, searchOnChange = true }) => {
  const [selectedFilter, setSelectedFilter] = useState('display_name');
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [searchTerm, setSearchTerm] = useState('');
  const [customerType, setCustomerType] = useState('');

  useEffect(() => {
    // Reset pagination to page 0 when filters change
    setPagination((prev) => ({ ...prev, page: 0 }));
  }, [selectedFilter, customerType]);

  useEffect(() => {
    let query = buildQuery();
    setCurrentQuery(query);
  }, [selectedFilter, customerType, pagination]);

  const buildQuery = () => {
    const filters = { ...defaultQuery };
    if (searchTerm) {
      filters[selectedFilter] = searchTerm;
    }
    if (customerType) {
      filters.customer_type = customerType;
    }

    return buildListParams(pagination, filters);
  };

  const [currentQuery, setCurrentQuery] = useState(buildQuery());

  useEffect(() => {
    if (!searchOnChange) return;

    const handler = debounce(() => {
      setCurrentQuery(buildQuery());
      // Reset pagination to page 0 when search changes
      setPagination((prev) => ({ ...prev, page: 0 }));
    }, 500);

    handler();
    return () => handler.cancel();
  }, [searchTerm]);

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handleCustomerTypeChange = (type) => setCustomerType(type);

  const handlePaginationChange = (page, limit) => setPagination({ page: page, size: limit });

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
      setPagination((prev) => ({ ...prev, page: 0 }));
    }
  };

  return {
    searchTerm,
    selectedFilter,
    currentQuery,
    customerType,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleCustomerTypeChange,
    handlePaginationChange,
  };
};

export default useMeterFilters;
